module.exports = __webpack_public_path__ + "img/19.12779bb7.png";